import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import orderStatusList from './orderStatusList';
import { useStylesTabs, useStylesTab } from './styles';

const OrderStatusTabs = props => {
  const classesTabs = useStylesTabs();
  const classesTab = useStylesTab();

  return (
    <Tabs
      {...props}
      variant="scrollable"
      scrollButtons
      classes={classesTabs}
      TabIndicatorProps={{ children: <span /> }}
    >
      {orderStatusList.map(orderStatus => (
        <Tab
          key={orderStatus.label}
          label={orderStatus.label}
          value={orderStatus.value}
          classes={classesTab}
        />
      ))}
    </Tabs>
  );
};

export default OrderStatusTabs;
